import { I as Icon, _ as _extends } from './Icon-f29ff1c6.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const CheckCircle = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M12 2C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10 5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10zm4.9945 6.7929c.3905.3905.3905 1.0237 0 1.4142l-5.6583 5.6583a.9987.9987 0 01-.8704.2795.9962.9962 0 01-.5466-.2802l-2.8294-2.8294c-.3909-.3908-.3909-1.0246 0-1.4154.3909-.3909 1.0246-.3909 1.4155 0l2.124 2.124 4.951-4.951c.3905-.3905 1.0237-.3905 1.4142 0z",
      clipRule: "evenodd"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M12 2C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10 5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10zm4.9945 6.7929c.3905.3905.3905 1.0237 0 1.4142l-5.6583 5.6583a.9987.9987 0 01-.8704.2795.9962.9962 0 01-.5466-.2802l-2.8294-2.8294c-.3909-.3908-.3909-1.0246 0-1.4154.3909-.3909 1.0246-.3909 1.4155 0l2.124 2.124 4.951-4.951c.3905-.3905 1.0237-.3905 1.4142 0z",
      clipRule: "evenodd"
    }),
    stroke: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      d: "M16.9945 8.7929c.3905.3905.3905 1.0237 0 1.4142l-5.6583 5.6583a.9987.9987 0 01-.8704.2795.9962.9962 0 01-.5466-.2802l-2.8294-2.8294c-.3909-.3908-.3909-1.0246 0-1.4154.3909-.3909 1.0246-.3909 1.4155 0l2.124 2.124 4.951-4.951c.3905-.3905 1.0237-.3905 1.4142 0z"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M2 12C2 6.4771 6.4771 2 12 2c5.5228 0 10 4.4771 10 10 0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10zm2 0c0-4.4183 3.5817-8 8-8s8 3.5817 8 8-3.5817 8-8 8-8-3.5817-8-8z",
      clipRule: "evenodd"
    }))
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
CheckCircle.displayName = "CheckCircleIcon";

export { CheckCircle, CheckCircle as default };
